import React, { useRef, useEffect } from 'react';
import './WarpBackground.css';

const WarpBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const resizeCanvas = () => {
      const parent = canvas.parentElement; // Get parent element dimensions
      canvas.width = parent.clientWidth;
      canvas.height = parent.clientHeight;
    };

    resizeCanvas(); // Set initial size
    window.addEventListener('resize', resizeCanvas);

    const stars = Array.from({ length: 200 }, () => ({
      x: Math.random() * canvas.width - canvas.width / 2,
      y: Math.random() * canvas.height - canvas.height / 2,
      z: Math.random() * canvas.width,
    }));

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    
      stars.forEach((star) => {
        const k = Math.max(128 / (star.z || 1), 0.1); // Avoid division by zero
        const px = star.x * k + canvas.width / 2;
        const py = star.y * k + canvas.height / 2;
    
        if (px >= 0 && px <= canvas.width && py >= 0 && py <= canvas.height) {
          const size = Math.max((1 - star.z / canvas.width) * 2, 0.5); // Clamp size
          ctx.fillStyle = 'white';
          ctx.beginPath();
          ctx.arc(px, py, size, 0, Math.PI * 2);
          ctx.fill();
        }
    
        star.z -= 2;
        if (star.z <= 0) {
          star.z = canvas.width;
          star.x = Math.random() * canvas.width - canvas.width / 2;
          star.y = Math.random() * canvas.height - canvas.height / 2;
        }
      });
    
      requestAnimationFrame(draw);
    };
    
    

    draw();

    return () => window.removeEventListener('resize', resizeCanvas);
  }, []);

  return (
    <canvas
  ref={canvasRef}
  style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
    pointerEvents: 'none',
  }}
/>

  );
};

export default WarpBackground;
